<template>
  <a-card :bordered="false">
    <div class="mb15">
      <a-button type="primary" icon="plus" @click="onEventClick(0)">新建</a-button>
    </div>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <template slot="customIndex" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <span slot="action" slot-scope="rowItem">
        <a @click="onEventClick(rowItem.record.id)">编辑</a>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'HotelMemberList',
  components: {},
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'HotelMemberList', title: '权益列表' },
      { name: 'HotelMemberInfo', title: '基础信息' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getCouponService().post('rights/queryRightsList', params)
    },
    onEventClick(id) {
      const params = {
        id: id,
        serverUniqueId: this.$route.query.serverUniqueId
      }
      this.openNewPage('NewHotelMember', params)
    },
    getColumnsList() {
      return [
        {
          title: '序号',
          dataIndex: 'customIndex',
          width: '60px',
          scopedSlots: { customRender: 'customIndex' }
        },
        {
          title: '权益名称',
          dataIndex: 'name',
          width: '25%'
        },
        {
          title: '券码ID',
          dataIndex: 'couponId'
        },
        {
          title: '状态',
          dataIndex: 'stateStr'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
